import {
    ADDING_CONTRIBUTOR,
    ADDING_CONTRIBUTOR_SUCCESS,
    ADDING_CONTRIBUTOR_FAILURE,
    RESET_ADDING_CONTRIBUTOR,
    GETTING_CONTRIBUTORS_BY_DASHBOARD,
    GETTING_CONTRIBUTORS_BY_DASHBOARD_SUCCESS,
    GETTING_CONTRIBUTORS_BY_DASHBOARD_FAILURE,
    RESET_GETTING_CONTRIBUTORS_BY_DASHBOARD,
    UPDATING_CONTRIBUTOR,
    UPDATING_CONTRIBUTOR_SUCCESS,
    UPDATING_CONTRIBUTOR_FAILURE,
    RESET_UPDATING_CONTRIBUTOR,
    DELETING_CONTRIBUTOR,
    DELETING_CONTRIBUTOR_SUCCESS,
    DELETING_CONTRIBUTOR_FAILURE,
    RESET_DELETING_CONTRIBUTOR
} from 'redux/reduxConstants';

export function addingContributor() {
    return { type: ADDING_CONTRIBUTOR };
}
export function addingContributorSuccess(newContributor) {
    return { type: ADDING_CONTRIBUTOR_SUCCESS, newContributor };
}
export function addingContributorFailure(error) {
    return { type: ADDING_CONTRIBUTOR_FAILURE, error };
}
export function resetAddingContributor() {
    return { type: RESET_ADDING_CONTRIBUTOR };
}

export function gettingContributorsByDashboard() {
    return { type: GETTING_CONTRIBUTORS_BY_DASHBOARD };
}
export function gettingContributorsByDashboardSuccess(contributors) {
    return { type: GETTING_CONTRIBUTORS_BY_DASHBOARD_SUCCESS, contributors };
}
export function gettingContributorsByDashboardFailure(error) {
    return { type: GETTING_CONTRIBUTORS_BY_DASHBOARD_FAILURE, error };
}
export function resetGettingContributorsByDashboard() {
    return { type: RESET_GETTING_CONTRIBUTORS_BY_DASHBOARD };
}

export function updatingContributor() {
    return { type: UPDATING_CONTRIBUTOR };
}
export function updatingContributorSuccess(contributor) {
    return { type: UPDATING_CONTRIBUTOR_SUCCESS, contributor };
}
export function updatingContributorFailure(error) {
    return { type: UPDATING_CONTRIBUTOR_FAILURE, error };
}
export function resetUpdatingContributor() {
    return { type: RESET_UPDATING_CONTRIBUTOR };
}

export function deletingContributor() {
    return { type: DELETING_CONTRIBUTOR };
}
export function deletingContributorSuccess(contributor) {
    return { type: DELETING_CONTRIBUTOR_SUCCESS, contributor };
}
export function deletingContributorFailure(error) {
    return { type: DELETING_CONTRIBUTOR_FAILURE, error };
}
export function resetDeletingContributor() {
    return { type: RESET_DELETING_CONTRIBUTOR };
}